import { useQuery } from "@tanstack/react-query";

import type { CosignatureQueueResponse, CosignatureStatusParam } from "@/core/types";
import { CosignatureStatusEnum } from "@/core/constants";

import { optionFactory as cosignatureQueueOptionFactory } from "./useCosignatureQueue";

const DEFAULT_STATUS =
  `${CosignatureStatusEnum.PENDING},${CosignatureStatusEnum.RESUBMITTED}` as CosignatureStatusParam;

type UseNeedsReviewQueueProps<TData = CosignatureQueueResponse> = {
  cosignature_status?: CosignatureStatusParam;
  enabled?: boolean;
  select?: (data: CosignatureQueueResponse) => TData;
  supervisor_id?: string;
};

function optionFactory(
  { cosignature_status, supervisor_id }: Omit<UseNeedsReviewQueueProps, "select" | "enabled"> = {},
  enabled = true,
) {
  return cosignatureQueueOptionFactory(
    {
      cosignature_status: cosignature_status ?? DEFAULT_STATUS,
      supervisor_id,
    },
    enabled,
  );
}

export function useNeedsReviewQueue<TData = CosignatureQueueResponse>({
  cosignature_status,
  enabled,
  select,
  supervisor_id,
}: UseNeedsReviewQueueProps<TData> = {}) {
  return useQuery({ ...optionFactory({ cosignature_status, supervisor_id }, enabled), select });
}
